(function () {
  var SELECTOR = '.product-listing__quick-add-to-cart-trigger';

  function getCartConfig() {
    var configEl = document.getElementById('cart-config');
    if (!configEl) return null;

    try {
      return JSON.parse(configEl.innerHTML || '{}');
    } catch (error) {
      console.error('Quick add: unable to parse cart config', error);
      return null;
    }
  }

  function openCart(config) {
    if (config.cart_added_event !== 'go_to_active_cart') return;

    if (config.cart_action === 'drawer') {
      Shopify.theme.ajaxCart.showDrawer(config);
    } else if (config.cart_action === 'modal_cart') {
      Shopify.theme.ajaxCart.showModal(config);
    } else if (config.cart_action === 'page_only') {
      window.location.href = config.cart_url;
    }
  }

  function resetButton(button, label) {
    button.disabled = false;
    button.classList.remove('is-loading');
    button.removeAttribute('aria-busy');
    button.textContent = label;
  }

  function handleQuickAddClick(event) {
    var button = event.target.closest(SELECTOR);
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    if (button.disabled || button.classList.contains('is-loading')) return;

    var variantId = parseInt(button.dataset.variantId, 10);
    if (!variantId) return;

    if (!window.Shopify || !Shopify.theme || !Shopify.theme.cart || !Shopify.theme.ajaxCart) {
      return;
    }

    var config = getCartConfig();
    if (!config) return;

    var defaultLabel = button.textContent.trim();
    button.disabled = true;
    button.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');
    button.textContent = config.adding_to_cart;

    Shopify.theme.cart
      .addItem(variantId, { quantity: 1 })
      .then(function () {
        button.textContent = config.added_to_cart;
        button.disabled = false;
        button.classList.remove('is-loading');
        button.removeAttribute('aria-busy');

        return Shopify.theme.cart.getCart().then(function (cart) {
          Shopify.theme.ajaxCart.updateView(config, cart);
          openCart(config);
        });
      })
      .then(function () {
        setTimeout(function () {
          button.textContent = defaultLabel;
        }, 3000);
      })
      .catch(function (error) {
        resetButton(button, defaultLabel);

        if (error && error.status === 422) {
          window.alert(config.cart_error || 'Unable to add this item to your cart.');
          return;
        }

        console.error('Quick add to cart failed', error);
      });
  }

  function initQuickAddToCart() {
    document.removeEventListener('click', handleQuickAddClick);
    document.addEventListener('click', handleQuickAddClick);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initQuickAddToCart);
  } else {
    initQuickAddToCart();
  }
})();
